import React from "react";
// import { useFormik } from "formik";
// import { toast } from 'react-toastify';

import Ouvidoria from "../../components/Ouvidoria";
import './trabalheConosco.scss';
import Photo from '../../assets/pictures/jobs.png';
import TitleAbout from "../../components/Title";
import SEO from "../../SEO/SEO";

export default function TrabalheConosco() {
  return (
    <>
      <SEO title="Trabalhe Conosco - Séculos Engenharia e Serviços LTDA" link="https://seculosengenharia.com.br/trabalheconosco" />
      <TitleAbout name="Trabalhe Conosco" link1={"Home/ "} link2={"Trabalhe Conosco"} />

      <section id='workour'>
        <div>
          <div className='workour'>
            <div className='desc-workour'
              data-aos="fade-zoom-in"
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offset="0">
              <h3>Junte-se a nossa equipe</h3>
              <p>Bem-vindo à página de carreiras da Séculos Engenharia e Serviços LTDA! Aqui, acreditamos que nossos colaboradores são o coração da nossa organização. Deseja fazer parte de uma equipe dinâmica e inovadora, você está no lugar certo. Valorizamos a diversidade, a criatividade e o comprometimento. Junte-se a nós e ajude-nos a construir um futuro brilhante!</p>
            </div>
            <div className='desc-workour'>
              <img className='img-fluid' src={Photo} width="650" alt="img-about-enterprise"
                data-aos="fade-zoom-in"
                data-aos-duration="1000"
                data-aos-delay="300"
                data-aos-offset="0"
              />
            </div>
          </div>
        </div>
      </section>

      <section id="formsWorkour">
        <div className="formsWorkour container">
          <div>
            <h2
              data-aos-delay="300"
              data-aos-offset="0">Venha fazer parte do nosso time!</h2>
          </div>
          <div className="formsContainerBox">
            <div className="formsWorkBox">
              <div className="formsSmallBox">
                <div className='box' 
                  data-aos-delay="300"
                  data-aos-offse="0">
                    <h2>oportunidades</h2>
                    <p>Estamos sempre em busca de novos talentos. Se você é dedicado, criativo e comprometido, confira as vagas disponíveis e envie seu currículo. Junte-se a nós e construa seu futuro em um ambiente dinâmico e inovador.</p>
                </div>
                <div className='box' 
                  data-aos-delay="300"
                  data-aos-offse="0">
                    <h2>inovação</h2>
                    <p>Nossa força está na inovação. Aqui, incentivamos ideias novas e soluções criativas. Faça parte de uma equipe que se reinventa constantemente e busca aprimorar processos, produtos e serviços.</p>
                </div>
                <div className='box' 
                  data-aos-delay="300"
                  data-aos-offse="0">
                    <h2>compromisso</h2>
                    <p>Nosso compromisso é com a excelência. Valorizamos a responsabilidade e a dedicação em cada tarefa. Se você busca um ambiente profissional que preza pela integridade e qualidade, venha trabalhar conosco.</p>
                </div>
                <div className='box' 
                  data-aos-delay="300"
                  data-aos-offse="0">
                    <h2>conhecimento</h2>
                    <p>O conhecimento impulsiona nosso crescimento. Promovemos o aprendizado contínuo e a troca de experiências. Junte-se a nós se você valoriza o desenvolvimento pessoal e profissional e quer contribuir para um ambiente de aprendizado constante.</p>
                </div>
              </div>
            </div>

            {/* <div className="formsWorkBox">
              <div className="formsWorkour-form">
                  <p>Preencha o formulário e envie seu currículo.</p>
                <div className="form"
                  data-aos-duration="1000">
                  <form 
                    method="post"
                    action="/controllers/controllerForm.php"
                    data-aos-delay="300"
                    data-aos-offset="0">
                    <input
                      id="name"
                      name="name"
                      type="text"
                      placeholder="Nome"
                      onChange={formik.handleChange}
                      value={formik.values.name}
                    />
                    {formik.errors.name ? <div>{formik.errors.name}</div> : null}
                    <br/>
                    <input
                      id="email"
                      name="email"
                      type="text"
                      placeholder="E-mail"
                      onChange={formik.handleChange}
                      value={formik.values.email}
                    />
                    {formik.errors.email ? <div>{formik.errors.email}</div> : null}
                    <br/>
                    <input
                      id="phone"
                      name="phone"
                      type="text"
                      placeholder="Telefone"
                      onChange={handlePhoneChange}
                      value={formik.values.phone}
                    />
                    {formik.errors.phone ? <div>{formik.errors.phone}</div> : null}
                    <br/>
                    <input
                      id="profissao"
                      name="profissao"
                      type="text"
                      placeholder="Profissão"
                      onChange={formik.handleChange}
                      value={formik.values.profissao}
                    />
                    <br/>
                    <input
                      id="city"
                      name="city"
                      type="text"
                      placeholder="Cidade"
                      onChange={formik.handleChange}
                      value={formik.values.city}
                    />
                    <br/>
                    <textarea
                      id="message"
                      name="message"
                      placeholder="Digite sua mensagem"
                      onChange={formik.handleChange}
                      value={formik.values.message}
                    />
                    {formik.errors.message ? <div>{formik.errors.message}</div> : null}
                    <br/>
                    <input
                      className="inputFile"
                      id="file"
                      name="file"
                      type="file"
                      onChange={(event) => {
                        formik.setFieldValue("file", event.currentTarget.files[0]);
                      }}
                    />
                    {formik.errors.file ? <div>{formik.errors.file}</div> : null}
                    <br/>
                      <input type="submit" placeholder="Enviar"/>
                  </form>
                </div>
              </div>
            </div> */}
          </div>
          <div className="button_box">
            <button className="button_cv">
              <a href="https://seculosengenharia.com.br/oportunidades/" target="blank">CADASTRAR MEU CURRÍCULO</a>
            </button>
          </div>
        </div>
      </section>
      <Ouvidoria />
    </>
  );
}
